import React from 'react'
import PropTypes from 'prop-types'
import {
  BaseComponent,
  Icon,
} from 'belle-js'
import classnames from 'classnames'
import styles from './Subnavigation.module.scss'

class SubnavigationItem extends BaseComponent {

  constructor (props) {
    super(props)
    this.state = {
      open: false
    }
    this.bind('handleClick', 'toggleDropdown', 'handleClickOutside')
    this.dropdownRef = React.createRef()
  }

  handleClick () {
    const { toggleDropdown } = this
    const { label, onClick, isDropdown } = this.props
    isDropdown ? toggleDropdown() : onClick(label)
  }

  componentDidMount () {
    document.addEventListener('mousedown', this.handleClickOutside)
  }

  componentWillUnmount () {
    document.removeEventListener('mousedown', this.handleClickOutside)
  }

  handleClickOutside (event) {
    const {
      current
    } = this.dropdownRef
    if (current && !current.contains(event.target)) {
      this.setState({
        open: false
      })
    }
  }

  toggleDropdown () {
    this.setState(prevState => ({
      open: !prevState.open
    }))
  }

  renderSubnavChildren () {
    const {
      children
    } = this.props

    return React.Children.map(children, (child) => {
      if (!child) return
      const onClickProp = {
        onClick: this.props.onClick
      }
      if (child.type.toString() === React.Fragment.toString()) {
        return  React.Children.map(child.props.children, child => (
          React.cloneElement(child, {
            key: child.props.label,
            ...onClickProp
          })
        ))
      }
      return React.cloneElement(child, {
        key: child.props.label,
        ...onClickProp,
      })
    }
    )
  }

  render () {
    const { handleClick } = this
    const {
      activeTab,
      isDropdown,
      label,
    } = this.props
    const { open } = this.state

    let subNavItem = (
      <li>
        <button
          data-test-id={`subNavigationItem_${label}`}
          type="button"
          className={classnames(styles.actions, activeTab === label ? styles.activeTab : '')}
          onClick={handleClick}>
          {label}
        </button>
      </li>
    )

    if (isDropdown) {
      subNavItem = (
        <li ref={this.dropdownRef}>
          <button
            data-test-id={`SubnavigationDropdownItem_${label}`}
            type="button"
            className={classnames(styles.actions)}
            onClick={handleClick}>
            {label}
            <span className={styles.stateIcon}>
              <span className={classnames({
                [styles.arrowOpened]: open,
                [styles.arrowClosed]: !open })} />
              { open ?
                <Icon icon="close_15" width={14} height={14} /> :
                <Icon icon="add_15" width={14} height={14} />
              }
            </span>
          </button>
          { open &&
            <ul className={styles.children}>
              {this.renderSubnavChildren()}
            </ul>
          }
        </li>
      )
    }
    return subNavItem
  }

}

SubnavigationItem.defaultProps = {
  isDropdown: false,
}

SubnavigationItem.propTypes = {
  activeTab: PropTypes.string,
  children: PropTypes.node,
  label: PropTypes.string,
  isDropdown: PropTypes.bool,
  onClick: PropTypes.func,
}

export default SubnavigationItem



// WEBPACK FOOTER //
// ./src/components/Client/Subnavigation/SubnavigationItem.js